import { defineMessages } from 'react-intl';

export default defineMessages({
  dayPlaceholder: {
    id: 'cc4.form.birthday-picker.day-placeholder',
    defaultMessage: `Day`,
  },
  monthPlaceholder: {
    id: 'cc4.form.birthday-picker.month-placeholder',
    defaultMessage: `Month`,
  },
  yearPlaceholder: {
    id: 'cc4.form.birthday-picker.year-placeholder',
    defaultMessage: `Year`,
  },
});
